export default {
    openMenu: 'Open Menu',
};
